import React, { useLayoutEffect } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';

import { ICategoryItem } from '../../../categories/interfaces';
import { ReactComponent as MenuBtn } from '../../../../../../_base/layout/assets/layout-svg-icons/menu-button-black.svg';
import { useGetProductsByCategory } from './useGetProductsByCategory';
import ProductsGrid from '../ProductGrid/ProductsGrid';
import { IAppState } from '../../../../../store/rootDuck';

const Wrapper = styled(Typography)({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  color: '#181c32',
  fontWeight: 'bold',
  fontSize: 17,
});

const HoverGroup = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  cursor: 'pointer',

  '&:hover .category': {
    color: '#006997',
  },
  '&:hover .icon': {
    fill: '#006997',
  },
});

const Category = styled('span')({
  cursor: 'pointer',
  transition: 'color 0.3s',
  '&:hover': {
    color: '#006997', // синий
  },
});

const StyledMenuBtn = styled(MenuBtn)({
  width: 20,
  height: 20,
  cursor: 'pointer',
  flexShrink: 0,
});

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  marginBottom: '20px',
});

export function NewProductsByCategory({
  category,
  handlePressCategoryTitle,
}: {
  category: ICategoryItem;
  handlePressCategoryTitle: (category: ICategoryItem) => void;
}) {
  const { me } = useSelector((store: IAppState) => ({
    me: store.profile.me,
  }));
  const { fetch, products, loading } = useGetProductsByCategory();

  useLayoutEffect(() => {
    if (category.id)
      fetch({
        id: category.id,
        page: 1,
        per_page: 5,
        sort_type: 'new',
      });
  }, [category]);

  if (loading) return null;

  return (
    <Container>
      <Wrapper>
        Новые товары в категории
        <HoverGroup onClick={() => handlePressCategoryTitle(category)}>
          <Category className='category'>«{category.name}»</Category>
          <StyledMenuBtn className='icon' />
        </HoverGroup>
      </Wrapper>
      <ProductsGrid me={me} data={products} />
    </Container>
  );
}
